export const toastPt = {
  messageIcon: 'pv-toast-message-icon'
};